import styled from '@emotion/styled';

export const Container = styled.div`
    margin: auto;
    & > * {
        margin: 2em auto;
    }
`;
